
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin } from "@/mixins/VuetifyMixin";

@Component
export default class ExcelDataTable extends Mixins(VuetifyMixin) {
}
